export default {
    objects: "object",
    decorations: "decoration",
    portraits: "artwork",
}
